import OldPointManage from '@/pages/oldPlatform/oldPointManage'

export default [{
  path: '/oldPointManage',
  name: 'OldPointManage',
  component: OldPointManage,
  meta: {
    name: '活跃导出',
    keepAlive: true
  }
}]



// WEBPACK FOOTER //
// ./src/router/oldPlatform/oldPointManage.js